// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_ItemInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /implantacao/item — a franqueadora muda a situação de um item (Full).
 * acao: aprovar | recusar | dispensar | reabrir. motivo é obrigatório para recusar e
 * dispensar; data_referencia (AAAA-MM-DD) é a data de entrega da COF. Chamado NS 2026-0079.
 */
import { registerContract } from './validate'

export interface Implantacao_ItemInput {
franquia_id?: number
item_chave?: string
acao?: string
motivo?: string
data_referencia?: string
}

registerContract('Implantacao_ItemInput', {
  franquia_id:     { type: 'number',  required: false },
  item_chave:      { type: 'string',  required: false },
  acao:            { type: 'string',  required: false },
  motivo:          { type: 'string',  required: false },
  data_referencia: { type: 'string',  required: false },
})
